import { Navigate } from "react-router-dom";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import ProtectedRoute from "./project/utils/protectedRoute";

import NotFound from "./views/sessions/NotFound";
import Elements from "./views/inicio/Elements";
import LoginComponent from "./project/components/login/LoginComponent";
import IngresoArticuloTable from "./project/components/ingreso-articulo/IngresoArticuloTable";
import IngresoArticulo from "./project/components/ingreso-articulo/IngresoArticulo";
import EnvioArticuloTable from "./project/components/envio-articulo/EnvioArticuloTable";
import EnvioArticulo from "./project/components/envio-articulo/EnvioArticulo";
import RecepcionArticuloTable from "./project/components/recepcion-articulo/RecepcionArticuloTable";
import RecepcionArticulo from "./project/components/recepcion-articulo/RecepcionArticulo";
import AjusteArticuloTable from "./project/components/ajuste-articulo/AjusteArticuloTable";
import AjusteArticulo from "./project/components/ajuste-articulo/AjusteArticulo";
import AreaTable from "./project/components/area/AreaTable";
import TipoAjusteStockTable from "./project/components/tipo-ajuste-stock/TipoAjusteStockTable";
import RecepcionOrdenEnvioTable from "./project/components/recepcion-orden-envio/RecepcionOrdenEnvioTable";
import ArCategoriaTable from "./project/components/ar-categoria/ArCategoriaTable";
import ArMarcaTable from "./project/components/ar-marca/ArMarcaTable";
import ArTipoTable from "./project/components/ar-tipo/ArTipoTable";
import ArMaterialTable from "./project/components/ar-material/ArMaterialTable";
import ArFormatoTable from "./project/components/ar-formato/ArFormatoTable";
import ArColorTable from "./project/components/ar-color/ArColorTable";
import ArCalibreTable from "./project/components/ar-calibre/ArCalibreTable";
import AsCategoriaTable from "./project/components/as-categoria/AsCategoriaTable";
import AsMarcaTable from "./project/components/as-marca/AsMarcaTable";
import AsTipoTable from "./project/components/as-tipo/AsTipoTable";
import AsMaterialTable from "./project/components/as-material/AsMaterialTable";
import AsFormatoTable from "./project/components/as-formato/AsFormatoTable";
import AsColorTable from "./project/components/as-color/AsColorTable";
import AsCalibreTable from "./project/components/as-calibre/AsCalibreTable";
import AsColorLenteTable from "./project/components/as-color-lente/AsColorLenteTable";
import TrMarcaTable from "./project/components/tr-marca/TrMarcaTable";
import TrTipoTable from "./project/components/tr-tipo/TrTipoTable";
import SlMarcaTable from "./project/components/sl-marca/SlMarcaTable";
import SlIndicacionTable from "./project/components/sl-indicacion/SlIndicacionTable";
import SlPresentacionTable from "./project/components/sl-presentacion/SlPresentacionTable";
import SlLaboratorioTable from "./project/components/sl-laboratorio/SlLaboratorioTable";
import LcDiametroTable from "./project/components/lc-diametro/LcDiametroTable";
import LcCurvaTable from "./project/components/lc-curva/LcCurvaTable";
import LcTiempoUsoTable from "./project/components/lc-tiempo-uso/LcTiempoUsoTable";
import LcSubmarcaTable from "./project/components/lc-submarca/LcSubMarcaTable";
import LcMarcaTable from "./project/components/lc-marca/LcMarcaTable";
import LcColorTable from "./project/components/lc-color/LcColorTable";
import LcTipoTable from "./project/components/lc-tipo/LcTipoTable";
import LcMaterialTable from "./project/components/lc-material/LcMaterialTable";
import LcDiagnosticoTable from "./project/components/lc-diagnostico/LcDiagnosticoTable";
import LcPresentacionTable from "./project/components/lc-presentacion/LcPresentacionTable";
import IngresoCristalTable from "./project/components/ingreso-cristal/IngresoCristalTable";
import IngresoCristal from "./project/components/ingreso-cristal/IngresoCristal";
import BlCrTipoTable from "./project/components/bl-cr-tipo/BlCrTipoTable";
import BlCrMaterialTable from "./project/components/bl-cr-material/BlCrMaterialTable";
import BlCrAdicionTable from "./project/components/bl-cr-adicion/BlCrAdicionTable";
import BlCrMarcaTable from "./project/components/bl-cr-marca/BlCrMarcaTable";
import BlCrColorTable from "./project/components/bl-cr-color/BlCrColorTable";
import BlCrSubmarcaTable from "./project/components/bl-cr-submarca/BlCrSubMarcaTable";
import BlCrDiametroTable from "./project/components/bl-cr-diametro/BlCrDiametroTable";
import BlCurvaTable from "./project/components/bl-curva/BlCurvaTable";
import BlEspesorTable from "./project/components/bl-espesor/BlEspesorTable";
import CrOrigenTable from "./project/components/cr-origen/CrOrigenTable";
import LcProductoTable from "./project/components/lc-producto/LcProductoTable";
import CristalProductoTable from "./project/components/cristal-producto/CristalProductoTable";
import BlockProductoTable from "./project/components/block-producto/BlockProductoTable";
import TratamientoTable from "./project/components/articulo-tratamiento/TratamientoTable";
import ServicioTable from "./project/components/articulo-servicio/ServicioTable";
import SolucionLimpiezaTable from "./project/components/articulo-solucion-limpieza/SolucionLimpiezaTable";
import SolucionLimpieza from "./project/components/articulo-solucion-limpieza/SolucionLimpieza";
import MaterialLaboratorioTable from "./project/components/articulo-material-laboratorio/MaterialLaboratorioTable";
import MaterialLaboratorio from "./project/components/articulo-material-laboratorio/MaterialLaboratorio";
import FornituraTable from "./project/components/articulo-fornitura/FornituraTable";
import Fornitura from "./project/components/articulo-fornitura/Fornitura";
import AccesorioTable from "./project/components/articulo-accesorio/AccesorioTable";
import Accesorio from "./project/components/articulo-accesorio/Accesorio";
import BlockTable from "./project/components/articulo-block/BlockTable";
import Block from "./project/components/articulo-block/Block";
import CristalTable from "./project/components/articulo-cristal/CristalTable";
import Cristal from "./project/components/articulo-cristal/Cristal";
import LenteContactoTable from "./project/components/articulo-lente-contacto/LenteContactoTable";
import LenteContacto from "./project/components/articulo-lente-contacto/LenteContacto";
import AnteojoSolTable from "./project/components/articulo-anteojo-sol/AnteojoSolTable";
import AnteojoSol from "./project/components/articulo-anteojo-sol/AnteojoSol";
import ArmazonTable from "./project/components/articulo-armazon/ArmazonTable";
import Armazon from "./project/components/articulo-armazon/Armazon";
import ValorServicioTable from "./project/components/valor-servicio/ValorServicioTable";
import ValorTratamientoTable from "./project/components/valor-tratamiento/ValorTratamientoTable";
import ValorFornituraTable from "./project/components/valor-fornitura/ValorFornituraTable";
import ValorAccesorioTable from "./project/components/valor-accesorio/ValorAccesorioTable";
import ValorSolucionLimpiezaTable from "./project/components/valor-solucion-limpieza/ValorSolucionLimpiezaTable";
import ValorBlockTable from "./project/components/valor-block/ValorBlockTable";
import ValorAnteojoSolTable from "./project/components/valor-anteojo-sol/ValorAnteojoSolTable";
import ValorArmazonTable from "./project/components/valor-armazon/ValorArmazonTable";
import ValorCristalTable from "./project/components/valor-cristal/ValorCristalTable";
import ValorLenteContactoTable from "./project/components/valor-lente-contacto/ValorLenteContactoTable";
import BlockCristalTable from "./project/components/bl-cristal/BlockCristalTable";
import BlockCristal from "./project/components/bl-cristal/BlockCristal";
import ProduccionTable from "./project/components/produccion/ProduccionTable";
import EnvioAnteojoArregloTable from "./project/components/envio-anteojo-arreglo/EnvioAnteojoArregloTable";
import EnvioAnteojoArregloNew from "./project/components/envio-anteojo-arreglo/EnvioAnteojoArregloNew";
import EnvioAnteojoArreglo from "./project/components/envio-anteojo-arreglo/EnvioAnteojoArreglo";
import ListaPrecioCristalTable from "./project/components/lista-precio-cristal/ListaPrecioCristalTable";
import ListaPrecioCristal from "./project/components/lista-precio-cristal/ListaPrecioCristal";
import ListaPrecioLenteContactoTable from "./project/components/lista-precio-lente-contacto/ListaPrecioLenteContactoTable";
import ListaPrecioLenteContacto from "./project/components/lista-precio-lente-contacto/ListaPrecioLenteContacto";
import ProveedorTable from "./project/components/proveedor/ProveedorTable";
import CondicionFrenteIvaTable from "./project/components/condicion-frente-iva/CondicionFrenteIvaTable";
import Configuracion from "./project/components/configuracion/Configuracion";
import SistemaTable from "./project/components/sistema/SistemaTable";
import SistemaRolTable from "./project/components/sistema-rol/SistemaRolTable";
import SistemaPermisoTable from "./project/components/sistema-permiso/SistemaPermisoTable";
import SistemaRolPermiso from "./project/components/sistema-rol-permiso/SistemaRolPermiso";
import UsuarioTable from "./project/components/usuario/UsuarioTable";
import SistemaRolUsuario from "./project/components/sistema-rol-usuario/SistemaRolUsuario";
import CambioPassword from "./project/components/password/CambioPassword";

const routes = [
  {
    element: (
      <ProtectedRoute>
        <MatxLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: "/inicio", element: <Elements /> },
      { path: "/ingreso-articulo-table", element: <IngresoArticuloTable /> },
      { path: "/ingreso-articulo/:idIngresoArticulo/:action", element: <IngresoArticulo /> },
      { path: "/ingreso-articulo/:action", element: <IngresoArticulo /> },
      { path: "/ingreso-cristal-table", element: <IngresoCristalTable /> },
      { path: "/ingreso-cristal/:idIngresoCristal/:action", element: <IngresoCristal /> },
      { path: "/ingreso-cristal/:action", element: <IngresoCristal /> },
      { path: "/envio-articulo-table", element: <EnvioArticuloTable /> },
      { path: "/envio-articulo/:idEnvio/:action", element: <EnvioArticulo /> },
      { path: "/envio-articulo/:action", element: <EnvioArticulo /> },
      { path: "/recepcion-articulo-table", element: <RecepcionArticuloTable /> },
      { path: "/recepcion-articulo/:idEnvio/:action", element: <RecepcionArticulo /> },
      { path: "/recepcion-articulo/:action", element: <RecepcionArticulo /> },
      { path: "/ajuste-articulo-table", element: <AjusteArticuloTable /> },
      { path: "/ajuste-articulo/:idAjuste/:action", element: <AjusteArticulo /> },
      { path: "/ajuste-articulo/:action", element: <AjusteArticulo /> },
      { path: "/tipo-ajuste-stock-table", element: <TipoAjusteStockTable /> },
      { path: "/area-table", element: <AreaTable /> },
      { path: "/condicion-frente-iva-table", element: <CondicionFrenteIvaTable /> },
      { path: "/proveedor-table", element: <ProveedorTable /> },
      { path: "/recepcion-orden-envio-table", element: <RecepcionOrdenEnvioTable /> },
      { path: "/ar-categoria-table", element: <ArCategoriaTable /> },
      { path: "/ar-marca-table", element: <ArMarcaTable /> },
      { path: "/ar-material-table", element: <ArMaterialTable /> },
      { path: "/ar-tipo-table", element: <ArTipoTable /> },
      { path: "/ar-formato-table", element: <ArFormatoTable /> },
      { path: "/ar-color-table", element: <ArColorTable /> },
      { path: "/ar-calibre-table", element: <ArCalibreTable /> },
      { path: "/as-categoria-table", element: <AsCategoriaTable /> },
      { path: "/as-marca-table", element: <AsMarcaTable /> },
      { path: "/as-material-table", element: <AsMaterialTable /> },
      { path: "/as-tipo-table", element: <AsTipoTable /> },
      { path: "/as-formato-table", element: <AsFormatoTable /> },
      { path: "/as-color-table", element: <AsColorTable /> },
      { path: "/as-calibre-table", element: <AsCalibreTable /> },
      { path: "/as-color-lente-table", element: <AsColorLenteTable /> },
      { path: "/tr-marca-table", element: <TrMarcaTable /> },
      { path: "/tr-tipo-table", element: <TrTipoTable /> },
      { path: "/sl-marca-table", element: <SlMarcaTable /> },
      { path: "/sl-indicacion-table", element: <SlIndicacionTable /> },
      { path: "/sl-presentacion-table", element: <SlPresentacionTable /> },
      { path: "/sl-laboratorio-table", element: <SlLaboratorioTable /> },
      { path: "/bl-cr-tipo-table", element: <BlCrTipoTable /> },
      { path: "/bl-cr-material-table", element: <BlCrMaterialTable /> },
      { path: "/bl-cr-adicion-table", element: <BlCrAdicionTable /> },
      { path: "/bl-cr-color-table", element: <BlCrColorTable /> },
      { path: "/bl-cr-marca-table", element: <BlCrMarcaTable /> },
      { path: "/bl-cr-submarca-table", element: <BlCrSubmarcaTable /> },
      { path: "/bl-cr-diametro-table", element: <BlCrDiametroTable /> },
      { path: "/bl-curva-table", element: <BlCurvaTable /> },
      { path: "/bl-espesor-table", element: <BlEspesorTable /> },
      { path: "/cr-origen-table", element: <CrOrigenTable /> },
      { path: "/lc-diametro-table", element: <LcDiametroTable /> },
      { path: "/lc-curva-table", element: <LcCurvaTable /> },
      { path: "/lc-tiempo-uso-table", element: <LcTiempoUsoTable /> },
      { path: "/lc-submarca-table", element: <LcSubmarcaTable /> },
      { path: "/lc-marca-table", element: <LcMarcaTable /> },
      { path: "/lc-color-table", element: <LcColorTable /> },
      { path: "/lc-tipo-table", element: <LcTipoTable /> },
      { path: "/lc-material-table", element: <LcMaterialTable /> },
      { path: "/lc-diagnostico-table", element: <LcDiagnosticoTable /> },
      { path: "/lc-presentacion-table", element: <LcPresentacionTable /> },
      { path: "/lc-producto-table", element: <LcProductoTable /> },
      { path: "/cristal-producto-table", element: <CristalProductoTable /> },
      { path: "/block-producto-table", element: <BlockProductoTable /> },
      { path: "/articulo/armazon-table", element: <ArmazonTable /> },
      { path: "/articulo/armazon/:idArticulo/:action", element: <Armazon /> },
      { path: "/articulo/anteojo-sol-table", element: <AnteojoSolTable /> },
      { path: "/articulo/anteojo-sol/:idArticulo/:action", element: <AnteojoSol /> },
      { path: "/articulo/lente-contacto-table", element: <LenteContactoTable /> },
      { path: "/articulo/lente-contacto/:idArticulo/:action", element: <LenteContacto /> },
      { path: "/articulo/cristal-table", element: <CristalTable /> },
      { path: "/articulo/cristal/:idArticulo/:action", element: <Cristal /> },
      { path: "/articulo/block-table", element: <BlockTable /> },
      { path: "/articulo/block/:idArticulo/:action", element: <Block /> },
      { path: "/articulo/accesorio-table", element: <AccesorioTable /> },
      { path: "/articulo/accesorio/:idArticulo/:action", element: <Accesorio /> },
      { path: "/articulo/fornitura-table", element: <FornituraTable /> },
      { path: "/articulo/fornitura/:idArticulo/:action", element: <Fornitura /> },
      { path: "/articulo/material-laboratorio-table", element: <MaterialLaboratorioTable /> },
      { path: "/articulo/material-laboratorio/:idArticulo/:action", element: <MaterialLaboratorio /> },
      { path: "/articulo/solucion-limpieza-table", element: <SolucionLimpiezaTable /> },
      { path: "/articulo/solucion-limpieza/:idArticulo/:action", element: <SolucionLimpieza /> },
      { path: "/articulo/servicio-table", element: <ServicioTable /> },
      { path: "/articulo/tratamiento-table", element: <TratamientoTable /> },
      { path: "/actualizacion-valor/servicio-table", element: <ValorServicioTable /> },
      { path: "/actualizacion-valor/tratamiento-table", element: <ValorTratamientoTable /> },
      { path: "/actualizacion-valor/fornitura-table", element: <ValorFornituraTable /> },
      { path: "/actualizacion-valor/accesorio-table", element: <ValorAccesorioTable /> },
      { path: "/actualizacion-valor/solucion-limpieza-table", element: <ValorSolucionLimpiezaTable /> },
      { path: "/actualizacion-valor/block-table", element: <ValorBlockTable /> },
      { path: "/actualizacion-valor/anteojo-sol-table", element: <ValorAnteojoSolTable /> },
      { path: "/actualizacion-valor/armazon-table", element: <ValorArmazonTable /> },
      { path: "/actualizacion-valor/cristal-table", element: <ValorCristalTable /> },
      { path: "/actualizacion-valor/lente-contacto-table", element: <ValorLenteContactoTable /> },
      { path: "/bl-cristal-table", element: <BlockCristalTable /> },
      { path: "/bl-cristal/:idBlCristal/:action", element: <BlockCristal /> },
      { path: "/bl-cristal/:action", element: <BlockCristal /> },
      { path: "/cr-lprecio-table", element: <ListaPrecioCristalTable /> },
      { path: "/cr-lprecio/:idCrLprecio/:action", element: <ListaPrecioCristal /> },
      { path: "/cr-lprecio/:action", element: <ListaPrecioCristal /> },
      { path: "/lc-lprecio-table", element: <ListaPrecioLenteContactoTable /> },
      { path: "/lc-lprecio/:idLcLprecio/:action", element: <ListaPrecioLenteContacto /> },
      { path: "/lc-lprecio/:action", element: <ListaPrecioLenteContacto /> },
      { path: "/produccion-table", element: <ProduccionTable /> },
      { path: "/envio-anteojo-arreglo-table", element: <EnvioAnteojoArregloTable /> },
      { path: "/envio-anteojo-arreglo/new", element: <EnvioAnteojoArregloNew /> },
      { path: "/envio-anteojo-arreglo/:action/:idEnvioAnteojoArreglo", element: <EnvioAnteojoArreglo /> },
      { path: "/configuracion", element: <Configuracion /> },
      { path: "/sistema-table", element: <SistemaTable /> },
      { path: "/sistema-rol-table", element: <SistemaRolTable /> },
      { path: "/sistema-permiso-table", element: <SistemaPermisoTable /> },
      { path: "/sistema-rol-permiso", element: <SistemaRolPermiso /> },
      { path: "/usuario-table", element: <UsuarioTable /> },
      { path: "/sistema-rol-usuario", element: <SistemaRolUsuario /> },
      { path: "/cambio-password", element: <CambioPassword /> },
    ]
  },
  { path: "/session/404", element: <NotFound /> },
  { path: "/login", element: <LoginComponent /> },
  { path: "/", element: <Navigate to="inicio" /> },
  { path: "*", element: <LoginComponent /> }
];
export default routes;
